import request from '@/utils/request'

export function login(code) {
  return request({
    url: '/api/associate/login',
    method: 'post',
    data: {
      code
    }
  })
}

export function getInfo(token) {
  return request({
    url: '/api/backend/admin/info',
    method: 'get',
    params: { }
  })
}

// export function logout() {
//   return request({
//     url: '/api/backend/user/logout',
//     method: 'post'
//   })
// }
